import styled from 'styled-components';
import { BREAK_POINTS, COLOURS } from '../../consts/style';
import { Text as Text_ } from '../Common/Text';

export const Card = styled.div`
  box-sizing: border-box;
  background-color: white;
  padding: 24px 16px;
  border-radius: 16px;
  height: 100%;

  display: grid;
  gap: 12px;
  grid-template-rows: auto auto 1fr auto; /* key rule */
  grid-template-areas:
    'stars date'
    'head head'
    'text text'
    'foot foot';

  @media screen and (min-width: ${BREAK_POINTS.Min.LG}) {
    padding: 24px;
  }
`;

export const Heading = styled.h3`
  grid-area: head;
  color: ${COLOURS.NEUTRALS.DARK};
  font-size: 16px;
  font-weight: 600;
  margin: 0;
`;

export const Text = styled(Text_)`
  grid-area: text;
`;

export const Date = styled(Text_)`
  grid-area: date;
  text-align: right;
  color: ${COLOURS.NEUTRALS.LIGHT};
`;

export const NameText = styled.p`
  grid-area: foot;

  margin: 0;
  color: ${COLOURS.NEUTRALS.LIGHT};
  font-size: 14px;
  text-transform: capitalize;
`;
